import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Typography from "@mui/material/Typography";
import { notBlank } from "../../util/ext";
import { Box, Link } from "@mui/material";

const useStyles = toolbarHeight =>
  makeStyles(theme => ({
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: toolbarHeight ? toolbarHeight : 70,
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "white",
      backgroundColor: "white",
      color: theme.palette.primary.main,
      padding: theme.spacing(4),
    },

    title: {
      flexGrow: 1,
      display: "flex",
      alignItems: "center",
      fontSize: "1.6rem",
    },

    link: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
    },
  }));

const Header = props => {
  const { selectedActions, title, subtitle, link, toolbarHeight } = props;

  const classes = useStyles(toolbarHeight)();

  return (
    <div>
      <div className={classes.toolbar}>
        <Box>
          {notBlank(title) && (
            <Typography variant="h1" style={{ fontWeight: "bolder" }}>
              {title}
            </Typography>
          )}

          {notBlank(subtitle) && (
            <Typography variant="h2" style={{ fontWeight: "bold" }}>
              {subtitle}
            </Typography>
          )}

          {notBlank(link) && (
            <Link
              href={link}
              target="_blank"
              variant="h2"
              className={classes.link}
            >
              {link}
            </Link>
          )}
        </Box>

        <div>{selectedActions && selectedActions}</div>
      </div>
    </div>
  );
};

export default Header;
